var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component, Fragment } from "react";
import styled from "styled-components";
import authentication from "@irati/auth";
import { H3 } from "@irati/ui/src/Headings";
import { Para, SmallCaption } from "@irati/ui/src/Labels";
import { Hr } from "@irati/ui/src/Layout";
import FormattedMessage, { injectIntl } from "@irati/utils/lang";
import EmojiWithText from "@irati/ui/src/EmojiWithText";
import padding from "@irati/ui/src/global/padding";
import { OnlineGPConsultationsTitle, PrescriptionServiceTitle, Tier1Info, Tier2Info, Tier3Info } from "./constants";
var Limits = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), padding.small);
var WrapperInsuranceButton = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: ", ";\n"], ["\n  margin-top: ", ";\n"])), padding.small);
var Popup = /** @class */ (function (_super) {
    __extends(Popup, _super);
    function Popup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buildPopup = function (title) {
            var hasTier2Access = authentication.apps("medical.tiers.tier2");
            var hasTier3Access = authentication.apps("medical.tiers.tier3");
            if (hasTier3Access) {
                var insuranceItem = Tier3Info.find(function (info) { return info.title === title; });
                if (title === OnlineGPConsultationsTitle || title === PrescriptionServiceTitle) {
                    return insuranceItem;
                }
                return __assign(__assign({}, insuranceItem), { terms: "medical.information.terms.3" });
            }
            if (hasTier2Access) {
                return Tier2Info.find(function (info) { return info.title === title; });
            }
            return Tier1Info.find(function (info) { return info.title === title; });
        };
        return _this;
    }
    Popup.prototype.render = function () {
        var _a = this.props, title = _a.title, formatMessage = _a.formatMessage;
        var hasTier2Access = authentication.apps("medical.tiers.tier2");
        var _b = this.buildPopup(title), desc = _b.desc, points = _b.points, terms = _b.terms, limits = _b.limits;
        var hideFurtherInformation = title === OnlineGPConsultationsTitle ||
            title === PrescriptionServiceTitle;
        return (React.createElement(Fragment, null,
            React.createElement(H3, { tiny: true }, formatMessage({ id: title })),
            React.createElement(Para, { large: true, light: true }, hasTier2Access
                ? React.createElement(FormattedMessage, { id: "medical.myMedical.popup.whatsIncluded.long" })
                : React.createElement(FormattedMessage, { id: "medical.myMedical.popup.whatsIncluded.short" })),
            React.createElement(Hr, null),
            desc && desc.map(function (line) {
                return React.createElement(Para, { key: title + "-" + line, narrow: true }, formatMessage({ id: line }));
            }),
            desc && React.createElement(Hr, null),
            React.createElement(Para, { bold: true },
                React.createElement(FormattedMessage, { id: "medical.myMedical.popup.whatIsCovered" })),
            points.map(function (point) { return (React.createElement(EmojiWithText, { key: "emojiWithText-" + point.text, emoji: point.emoji, isIcon: point.isIcon, text: formatMessage({ id: point.text }) })); }),
            limits && React.createElement(Limits, null,
                React.createElement(Para, { bold: true },
                    React.createElement(FormattedMessage, { id: "medical.myMedical.popup.limits" })),
                limits && React.createElement(Para, null, formatMessage({ id: limits }))),
            React.createElement(SmallCaption, null, formatMessage({ id: terms })),
            !hideFurtherInformation && React.createElement(WrapperInsuranceButton, null,
                React.createElement(Para, { bold: true },
                    React.createElement(FormattedMessage, { id: "medical.insurance.text" })))));
    };
    return Popup;
}(Component));
export default injectIntl(Popup);
var templateObject_1, templateObject_2;
